import * as types from '../constants';

export function loadDashboards() {
  return {
    type: types.LOAD_DASHBOARDS,
  };
}

export function loadDashboardDetails(uuid) {
  return {
    type: types.LOAD_DASHBOARD_DETAILS,
    uuid,
  };
}

export function createDashboard(data) {
  return {
    type: types.CREATE_DASHBOARD,
    data,
  };
}

export function updateDashboard(dashboard) {
  return {
    type: types.UPDATE_DASHBOARD,
    dashboard,
  };
}

export function updateDashboardCell(data) {
  return {
    type: types.UPDATE_DASHBOARD_CELL,
    data,
  };
}

export function deleteDashboard(dashboard) {
  return {
    type: types.DELETE_DASHBOARD,
    dashboard,
  };
}

export function loadWidgets() {
  return {
    type: types.LOAD_WIDGETS,
  };
}
